import { theme } from "@ovou-inc/ovou-ui";

import type { IProfile } from "types/Profile";
import { addSharpToColorHex, generateMediaPath } from "utils";

interface IBuildProfileCardPropsOptions {
  width: number;
  logoOverride?: string;
}

interface IProfileCardClient {
  user: {
    firstName: string;
    lastName: string;
    profileImage: string;
  };
  trade: {
    designation: string;
    organization: string;
    logo: string;
    showCompanyName: boolean;
    companyNameSeparator: string;
  };
  cardConfig: {
    width: number;
    template: {
      backgroundColor: string;
      careerForegroundColor: string;
      fullNameForegroundColor: string;
    };
  };
  canvasContext: {
    callback: () => null;
    mode: "react";
  };
}

export const buildProfileCardProps = (
  profile: IProfile,
  { width, logoOverride }: IBuildProfileCardPropsOptions,
): IProfileCardClient => {
  const logoSrc =
    logoOverride ?? (profile.logo ? generateMediaPath(profile.logo) : "");
  const designBg = profile.design?.background_color;
  const backgroundColor = designBg
    ? designBg.includes("linear")
      ? designBg.replace(";", "")
      : addSharpToColorHex(designBg)
    : theme.palette.brand.primary.white;

  return {
    user: {
      firstName: profile.first_name || "",
      lastName: profile.last_name || "",
      profileImage: profile.picture || "",
    },
    trade: {
      designation: profile.job_title,
      organization: profile.workplace,
      logo: logoSrc,
      showCompanyName: true,
      companyNameSeparator: "at",
    },
    cardConfig: {
      width,
      template: {
        backgroundColor,
        careerForegroundColor: profile.design?.career_foreground_color
          ? addSharpToColorHex(profile.design.career_foreground_color)
          : theme.palette.ui.greys.grey2,
        fullNameForegroundColor: profile.design?.full_name_foreground_color
          ? addSharpToColorHex(profile.design.full_name_foreground_color)
          : theme.palette.brand.primary.white,
      },
    },
    canvasContext: {
      callback: (): null => null,
      mode: "react",
    },
  };
};
